const mutations = {
  SET_LOADING_STATE(state, payload) {
    state.isLoading = payload.value;
  },
};
export default mutations;
